/**
 * TODO: 4.0
 * - remove `dataSource`
 * - `size` not work with customizeInput
 * - customizeInput not feedback `ENTER` key since accessibility enhancement
 */
import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import omit from 'omit.js';
import Select from '../select';
import { ConfigConsumer } from '../config-provider';
import warning from '../_util/warning';
const { Option } = Select;
const InternalSelect = Select;
function isSelectOptionOrSelectOptGroup(child) {
    return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const AutoComplete = (props, ref) => {
    const { prefixCls: customizePrefixCls, className, children, dataSource } = props;
    const childNodes = toArray(children);
    const selectRef = React.useRef();
    React.useImperativeHandle(ref, () => selectRef.current);
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1 &&
        React.isValidElement(childNodes[0]) &&
        !isSelectOptionOrSelectOptGroup(childNodes[0])) {
        customizeInput = childNodes[0];
    }
    const getInputElement = () => customizeInput;
    // ============================ Options ============================
    let optionChildren;
    // [Legacy] convert `children` or `dataSource` into option children
    if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
        optionChildren = children;
    }
    else {
        optionChildren = dataSource
            ? dataSource.map(item => {
                if (React.isValidElement(item)) {
                    return item;
                }
                switch (typeof item) {
                    case 'string':
                        return (<Option key={item} value={item}>
                  {item}
                </Option>);
                    case 'object': {
                        const { value: optionValue } = item;
                        return (<Option key={optionValue} value={optionValue}>
                  {item.text}
                </Option>);
                    }
                    default:
                        throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
                }
            })
            : [];
    }
    // ============================ Warning ============================
    React.useEffect(() => {
        warning(!('dataSource' in props), 'AutoComplete', '`dataSource` is deprecated, please use `options` instead.');
        warning(!customizeInput || !('size' in props), 'AutoComplete', 'You need to control style self instead of setting `size` when using customize input.');
    }, []);
    return (<ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('select', customizePrefixCls);
        return (<InternalSelect ref={selectRef} {...omit(props, ['dataSource'])} prefixCls={prefixCls} className={classNames(className, `${prefixCls}-auto-complete`)} mode={Select.SECRET_COMBOBOX_MODE_DO_NOT_USE} getInputElement={getInputElement}>
            {optionChildren}
          </InternalSelect>);
    }}
    </ConfigConsumer>);
};
const RefAutoComplete = React.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
export default RefAutoComplete;
